import React from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import WarningIcon from "@mui/icons-material/Warning";
import ErrorIcon from "@mui/icons-material/Error";
import { ContractRiskExposure } from "../../../types/contractDashboard";
import styles from "./contractRiskExposureTable.module.scss";

interface ContractRiskExposureTableProps {
  data: ContractRiskExposure[];
}

const ContractRiskExposureTable: React.FC<ContractRiskExposureTableProps> = ({ data }) => {
  const getSLAIcon = (performance: number) => {
    if (performance >= 80)
      return <CheckCircleIcon className={styles.slaIcon} style={{ color: "#10b981" }} />;
    if (performance >= 70)
      return <WarningIcon className={styles.slaIcon} style={{ color: "#f59e0b" }} />;
    return <ErrorIcon className={styles.slaIcon} style={{ color: "#ef4444" }} />;
  };

  const getRiskColor = (risk: string) => {
    if (risk === "Low") return "#10b981";
    if (risk === "Medium") return "#f59e0b";
    return "#ef4444";
  };

  return (
    <Box className={styles.container}>
      <Box className={styles.titleSection}>
        <Typography variant="h6" className={styles.title}>
          Contract Risk Exposure Score
        </Typography>
        <Typography variant="body2" className={styles.subtitle}>
          Assessment of SLA adherence, penalty clauses, and compliance gaps.
        </Typography>
      </Box>

      <TableContainer component={Paper} className={styles.tableContainer}>
        <Table className={styles.table}>
          <TableHead>
            <TableRow className={styles.headerRow}>
              <TableCell className={styles.headerCell}>CONTRACT</TableCell>
              <TableCell className={styles.headerCell}>SLA PERFORMANCE</TableCell>
              <TableCell className={styles.headerCell}>PENALTY RISK</TableCell>
              <TableCell className={styles.headerCell}>COMPLIANCE</TableCell>
              <TableCell className={styles.headerCell}>OVERALL RISK</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((contract, index) => (
              <TableRow key={index} className={styles.dataRow}>
                <TableCell className={styles.dataCell}>
                  {contract.contractName}
                </TableCell>
                <TableCell className={styles.dataCell}>
                  <Box className={styles.slaCell}>
                    {getSLAIcon(contract.slaPerformancePct)}
                    <Typography variant="body2" className={styles.slaText}>
                      {contract.slaPerformancePct}%
                    </Typography>
                  </Box>
                </TableCell>
                <TableCell className={styles.dataCell}>
                  {contract.penaltyRisk}
                </TableCell>
                <TableCell className={styles.dataCell}>
                  {contract.complianceLevel}
                </TableCell>
                <TableCell className={styles.dataCell}>
                  <Box
                    className={styles.riskCell}
                    style={{ color: getRiskColor(contract.overallRisk) }}
                  >
                    {contract.overallRisk} Risk
                  </Box>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default ContractRiskExposureTable;

